import { z } from 'zod';
import type { $brand } from 'zod/v4/core';

// Foreign, declared here rather than imported: same brand, no package edge — the rule the domain
// packages already follow for another context's ids.
export type SessionId = string & $brand<'SessionId'>;
export const sessionIdSchema = z.uuid().transform((id) => id as SessionId);
